import { ServerFilterableQueue } from "../components/ServerFilterableQueue";
import { TabHeading } from "../components/tab-states";
import { useBadges } from "../data/queries";

/**
 * The queue of proposals the machine IS confident about.
 *
 * The description is the load-bearing part: on this tab you are confirming a
 * decision the machine already made, and on Defer-to-human you are making one
 * it declined to. Reading them as the same queue is how a reviewer starts
 * rubber-stamping the half that needed their judgment.
 */
export function ReviewTab() {
  const badges = useBadges();
  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Review queue"
        description="Proposals the machine is confident enough to recommend. You are confirming a decision it has already made. Where it is not confident enough to recommend anything, the proposal goes to Defer-to-human for you to decide instead."
        aside={badges.data ? `${badges.data.review} waiting` : undefined}
      />
      <ServerFilterableQueue
        scope="review"
        showStatusFilter
        defaultStatus="proposed"
        emptyTitle="No proposals waiting."
        errorTitle="Could not load the review queue"
      />
    </div>
  );
}
